<template>
  <video ref="videoHome" preload played autoplay muted loop playsinline poster="" class="welcome-video">
    <source :src="video" type="video/mp4">
  </video>
</template>
<script>
export default {
  props:['video'],
  data(){
    return {
    }
  },
  methods: {
    playVideo() {
      this.$refs.videoHome.play()
    }
  },
  mounted(){
    this.playVideo()
  }
}
</script>
